<template lang="pug">
#bloco-infor-dados-br
    .bloco-infor-dados-br
        BlocoInformacaoSkeleton(:carregando='skeletonBlocoInforDados')
            BlocoInformacao(
                :titulo='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratosNaoVisualizado")',
                :numero='totalContratosOriginacao.totalNaoVisualizado',
                @click.native='aplicarFiltroStatus(statusEmitidos[0], 0)',
                :class='[codigosStatusAtivo[0].removeStatus ? "bloco-infor-dados-ativo" : ""]'
            )
                template(slot='icone')
                    i.mdi.mdi-eye-off-outline

        BlocoInformacaoSkeleton(:carregando='skeletonBlocoInforDados')
            BlocoInformacao(
                :titulo='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratosVisualizado")',
                :numero='totalContratosOriginacao.totalVisualizado',
                @click.native='aplicarFiltroStatus(statusEmitidos[1], 1)',
                :class='[codigosStatusAtivo[1].removeStatus ? "bloco-infor-dados-ativo" : ""]'
            )
                template(slot='icone')
                    i.mdi.mdi-eye-outline

        BlocoInformacaoSkeleton(:carregando='skeletonBlocoInforDados')
            BlocoInformacao(
                :titulo='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratosEmCadastramento")',
                :numero='totalContratosOriginacao.totalEmCadastramento',
                @click.native='aplicarFiltroStatus(statusEmitidos[2], 2)',
                :class='[codigosStatusAtivo[2].removeStatus ? "bloco-infor-dados-ativo" : ""]'
            )
                template(slot='icone')
                    i.mdi.mdi-pen-plus

        BlocoInformacaoSkeleton(:carregando='skeletonBlocoInforDados')
            BlocoInformacao(
                :titulo='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratosArquivado")',
                :numero='totalContratosOriginacao.totalArquivado',
                @click.native='aplicarFiltroStatus(statusEmitidos[4], 4)',
                :class='[codigosStatusAtivo[4].removeStatus ? "bloco-infor-dados-ativo" : ""]'
            )
                template(slot='icone')
                    i.mdi.mdi-archive

        BlocoInformacaoSkeleton(:carregando='skeletonBlocoInforDados')
            BlocoInformacao(
                :titulo='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratosConcluido")',
                :numero='totalContratosOriginacao.totalConcluido',
                @click.native='aplicarFiltroStatus(statusEmitidos[3], 3)',
                :class='[codigosStatusAtivo[3].removeStatus ? "bloco-infor-dados-ativo" : ""]'
            )
                template(slot='icone')
                    i.mdi.mdi-check-circle-outline

        BlocoInformacaoSkeleton(:carregando='skeletonBlocoInforDados')
            BlocoInformacao.text-with(
                :titulo='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.totalizadorEudr")',
                :numero='totalContratosOriginacao?.totalEudr',
                :class='{ "bloco-infor-dados-ativo": filtroTotalizadorEudr }',
                @click.native='handlerEudrFilter()'
            )
                template(slot='icone')
                    i.mdi.mdi-dots-circle
</template>

<script>
import BlocoInformacao from '@/components/contratosOriginacao/EmpresaBlocoInformacao.vue';
import BlocoInformacaoSkeleton from '@/components/contratosOriginacao/EmpresaBlocoInformacaoSkeleton.vue';

export default {
    components: {
        BlocoInformacao,
        BlocoInformacaoSkeleton
    },
    props: {
        totalContratosOriginacao: {
            type: Object,
            required: true
        },
        totalizador: {
            type: Number,
            required: true
        },
        skeletonBlocoInforDados: {
            type: Boolean,
            required: true
        },
        codigosStatusAtivo: {
            type: Array,
            required: true
        },
        filtroTotalizadorEudr: {
            type: [Boolean, String],
            default: false
        },
        statusEmitidos: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        handlerEudrFilter() {
            this.$emit('handlerEudrFilter');
        },
        aplicarFiltroStatus(status, index) {
            this.$emit('aplicarFiltroStatus', status, index);
        }
    }
};
</script>

<style lang="scss">
#bloco-infor-dados-br {
    .bloco-infor-dados-br {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 8px;
        width: 100%;
        flex-wrap: wrap;
        #empresa-bloco-informacao {
            cursor: pointer;
        }

        .text-with {
            .bloco-informacao__interno-texto {
                width: 100%;
                max-width: 150px !important;
                @media only screen and (min-width: 1080px) {
                    max-width: 210px !important;
                }
            }
        }
        & > div {
            width: 100% !important;
        }
    }
    .bloco-novos-contratos-preenchimento,
    .bloco-infor-dados-br,
    .bloco-pesquisa-filtros,
    .bloco-novos-contratos-tabela {
        margin-top: 20px;
    }
    .total-contratos {
        font-size: 19px;
        margin-right: 6px;
    }
    .secao-listagem-filtro {
        display: flex;
        margin-top: 20px;
        gap: 25px;
        justify-content: space-between;
        .el-checkbox__label,
        .titulo-listagem h3 {
            font-weight: bold;
        }
        .titulo-listagem {
            width: 50%;
        }
    }

    #empresa-bloco-informacao {
        border: 1px solid #e1e1e1;

        &.bloco-infor-dados-ativo {
            border-color: var(--primary) !important;
        }
    }

    .base-button-exportar-relatorio {
        width: 100%;
        margin-right: 0px;
        display: flex;
        justify-content: flex-end;
    }

    .base-button-container__btn {
        span {
            margin-left: 5px;
        }
    }
}
@media only screen and (max-width: 1200px) {
    .bloco-infor-dados-br > div {
        width: 49%;
    }
}
</style>
